import React from 'react';

import CustomToggleButtonGroup from '../ToggleButtonGroup';
import type { ToggleTab } from './types';

export interface PageHeaderToggleGroupProps {
  tabs: ToggleTab[];
  value: string;
  onChange: (value: string) => void;
}

const PageHeaderToggleGroup: React.FC<PageHeaderToggleGroupProps> = ({
  tabs,
  value,
  onChange,
}) => {
  if (tabs.length === 0) return null;

  const options = tabs.map((tab) => ({
    value: tab.value,
    label: tab.label,
    disabled: tab.disabled,
  }));

  return (
    <CustomToggleButtonGroup
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default PageHeaderToggleGroup;
